import { FC } from 'react';

import Select, { SelectProps } from 'components/Select';

type Props = Omit<SelectProps, 'options'>;

const options = [
  {
    value: 'PAGE',
    label: 'Puslapis',
  },
  {
    value: 'PACKAGES',
    label: 'Kelionės',
  },
  {
    value: 'ARTICLES',
    label: 'Ką pamatyti',
  },
  {
    value: 'EXTERNAL',
    label: 'Išorinis URL',
  },
];

const MenuItemTypeSelect: FC<Props> = props => (
  <Select options={options} {...props} />
);

export default MenuItemTypeSelect;
